import React from 'react'

const HeroSection = () => {
    return (
        <div className="relative text-white overflow-hidden flex flex-col justify-between pt-14"
            style={{ background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0.56%, #00101D 15.87%, #00101D 85.11%, rgba(0, 16, 29, 0) 100%)' }}>
            {/* Background */}
            <div className="w-full absolute top-0 right-0 z-0 h-full">
                <div className="w-full h-full absolute" style={{ background: 'linear-gradient(297.01deg, #2196F3 -116.99%, #000000 100%)' }}></div>
                <div className="w-full h-full">
                    <img className="w-full h-full object-cover opacity-40 lg:hidden" src="/assets/hero-bg-mobile.png" alt="Hero background" />
                    <img className="w-full hidden lg:block h-full object-cover opacity-80" src="/assets/hero-bg.png" alt="Hero background" />
                </div>
            </div>

            {/* Content Container */}
            <div className="max-w-7xl w-full mx-auto z-10 flex flex-col items-center">

                <img src="/assets/logo.png" alt="logo" className='w-[140px] md:hidden' />
                {/* Badges/Icons Row */}
                <div className="flex items-center justify-center w-full max-w-4xl mx-auto px-4 py-8 mt-0 md:mt-10">
                    <img className="w-auto h-32 left-10 sm:h-40 md:h-60 lg:left-16 object-contain relative" src="/assets/experience.png" alt="Experience badge" />
                    <img className="w-auto h-56 sm:h-64 md:h-96 object-contain" src="/assets/high-quality-apps.png" alt="High quality apps badge" />
                    <img className="w-auto h-32 right-10 sm:h-40 md:h-60 object-contain relative lg:right-16" src="/assets/ai-integration.png" alt="AI integration badge" />
                </div>

                {/* Australian Made Button */}
                <div className="w-full flex justify-center">
                    <button className="font-bold bg-background-blue text-[18px] text-white px-6 py-3 rounded-full hover:bg-blue-600 transition duration-150 hidden md:block">
                        Australian Made Apps
                    </button>

                    <div className='md:hidden py-3 -mt-4 bg-primary/20 w-full text-center flex justify-center'>
                        <p className='font-bold text-sm'>Australian Made Apps</p>
                    </div>
                </div>

                {/* Main Heading */}
                <h1 className="text-5xl mt-10 md:text-6xl lg:text-7xl font-light md:font-bold text-center my-4 md:my-8 px-4">
                    Achieve Global <span className='text-primary font-bold'>Success</span>
                </h1>

                <p className='text-sm font-medium text-center max-w-xs md:hidden pb-[140px]'>
                    Build powerful native apps, AI tools, and subscription platfroms - all from the one team.
                </p>

                {/* Stats Box */}
                <div className="w-full max-w-3xl mt-8 md:mt-2 px-4 hidden sm:block">
                    <div className="sm:bg-[#00101D] bg-black/40 border-t-[6px] sm:border-none border-primary/40 rounded-t-[25px] sm:rounded-t-[3.5rem] py-6 md:py-12 px-0 flex flex-wrap justify-center sm:justify-around gap-0 sm:shadow-[0px_-60px_70px_0px_#008EFF33] 
                               sm:bg-gradient-to-b from-[#00101D] to-[#002644]">
                        {/* Users */}
                        <div className="text-center px-2 sm:px-4 flex justify-start flex-col">
                            <div className="text-2xl font-medium md:font-extrabold text-white mb-2 md:text-5xl">
                                200k+
                            </div>
                            <div className="inline-block border border-white sm:border-blue-400 text-white sm:text-blue-400 text-[8px] md:text-xs px-2 sm:px-3 py-1 rounded-full w-fit font-medium sm:font-extrabold">
                                Users
                            </div>
                        </div>

                        {/* Payments Processed */}
                        <div className="text-center px-2 sm:px-4 flex justify-start flex-col">
                            <div className="text-2xl font-medium md:font-extrabold text-white mb-2 md:text-5xl">
                                100k+
                            </div>
                            <div className="inline-block border border-white sm:border-blue-400 text-white sm:text-blue-400 text-[8px] md:text-xs px-2 sm:px-3 py-1 rounded-full w-fit font-medium sm:font-extrabold">
                                Payments Processed
                            </div>
                        </div>

                        {/* Happy Clients */}
                        <div className="text-center px-2 sm:px-4 flex justify-start flex-col">
                            <div className="text-2xl font-medium md:font-extrabold text-white mb-2 md:text-5xl">
                                100+
                            </div>
                            <div className="inline-block border border-white sm:border-blue-400 text-white sm:text-blue-400 text-[8px] md:text-xs px-2 sm:px-3 py-1 rounded-full w-fit font-medium sm:font-extrabold">
                                Happy Clients
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeroSection

